import React, { useState, useMemo } from "react";
import { Toaster } from "sonner";
import TaskPanel from "./TaskPanel";
import MapPanel from "./MapPanel";
import AgentPanel from "./AgentPanel";
import SendNotificationModal from "../../Driver/SendNotificationModal";
import AssignModal from "../AssignModal";
import TaskDetailsModal from "../TaskDetailsModal";

export default function MapDashboardOld(props) {
  const {
    tasks,
    agents,
    teams,
    isLoading,
    setFromDate,
    setToDate,
    FetchTaskCall,
    FetchDriverCall,
    fetchTaskLogs,
    handleChangeStatus,
    SyncWithAnlook,
    AssignTaskToDriver,
    handleToggle,
    isChecked,
    baseurl,
    token,
    setIsUnauthorised,
    fetchCustomerInstructions,
    instructionTaskIds,
  } = props;
 const getToday = () => new Date().toISOString().split("T")[0];
  const [tempFromDate, setTempFromDate] = useState(
    props.fromDate || getToday(),
  );
  const [tempToDate, setTempToDate] = useState(props.toDate || getToday());
  const [selectedTaskTab, setSelectedTaskTab] = useState("unassigned");
  const [selectedAgentTab, setSelectedAgentTab] = useState("active");
  const [searchQuery, setSearchQuery] = useState("");

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [taskToAssign, setTaskToAssign] = useState(null);
  const [selectedAgentId, setSelectedAgentId] = useState("");

  const [selectedTask, setSelectedTask] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [notificationAgent, setNotificationAgent] = useState(null);

  const [assignmentLogs, setAssignmentLogs] = useState([]);
  const [statusChangeLogs, setStatusChangeLogs] = useState([]);
  const [showLogs, setShowLogs] = useState(false);

  const [instructionModalOpen, setInstructionModalOpen] = useState(false);
  const [taskInstructions, setTaskInstructions] = useState([]);
  const [loadingInst, setLoadingInst] = useState(false);
  const [assignTab, setAssignTab] = useState("team");
  const [selectedAssignTeam, setSelectedAssignTeam] = useState("");

  const handleInstructionClick = async (taskId) => {
    setLoadingInst(true);

    const allData = await fetchCustomerInstructions();

    const onlyThisTask = (allData || []).filter(
      (i) => String(i.task_id) === String(taskId),
    );

    setTaskInstructions(onlyThisTask);
    setInstructionModalOpen(true);
    setLoadingInst(false);
  };

  const teamDrivers = useMemo(() => {
    if (!selectedAssignTeam) return [];

    const teamData = teams?.find((t) => t.team_name === selectedAssignTeam);

    const ids = teamData?.driverlist?.map((d) => d.id?.toString()) || [];

    return (agents || []).filter(
      (a) =>
        ids.includes(a?.id?.toString()) ||
        ids.includes(a?.driverId?.toString()),
    );
  }, [selectedAssignTeam, teams, agents]);

  const allTeamDrivers = useMemo(() => {
    if (!selectedAssignTeam) return [];

    const teamData = teams?.find((t) => t.team_name === selectedAssignTeam);

    const ids = teamData?.driverlist?.map((d) => d.id?.toString()) || [];

    return (agents || []).filter(
      (a) =>
        ids.includes(a?.id?.toString()) ||
        ids.includes(a?.driverId?.toString()),
    );
  }, [selectedAssignTeam, teams, agents]);

  // ---------- FILTER TASKS  ----------
  const filteredTasks = useMemo(() => {
    if (!tasks) return [];

    if (selectedTaskTab === "unassigned") {
      return tasks.filter((task) => task.status === "unassigned");
    }

    if (selectedTaskTab === "successful") {
      return tasks.filter((task) => task.status === "successful");
    }

    return tasks.filter(
      (task) => !["unassigned", "successful"].includes(task.status),
    );
  }, [tasks, selectedTaskTab]);

  // ---------- FILTER AGENTS ----------
  const filteredAgents = useMemo(() => {
    let list =
      selectedAgentTab === "total"
        ? agents
        : agents.filter(
            (a) => a.dutyStatus?.toLowerCase() === selectedAgentTab,
          );

    return list.filter((a) =>
      a.fullName?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  }, [agents, selectedAgentTab, searchQuery]);

  const handleOpenTaskDetails = (task) => {
    setSelectedTask(task);
    setShowDetailsModal(true);
    setAssignmentLogs([]);
    setStatusChangeLogs([]);
    setShowLogs(false);
  };

  return (
    <div className="flex w-full h-full overflow-hidden">
      <Toaster position="top-right" />

      {/* LEFT PANEL */}
       <TaskPanel
        tasks={tasks}
        filteredTasks={filteredTasks}
        isLoading={isLoading}
        selectedTaskTab={selectedTaskTab}
        setSelectedTaskTab={setSelectedTaskTab}
        setTaskToAssign={setTaskToAssign}
        setShowAssignModal={setShowAssignModal}
        setSelectedTask={handleOpenTaskDetails}
        setShowDetailsModal={setShowDetailsModal}
        SyncWithAnlook={SyncWithAnlook}
        setFromDate={setFromDate}
        setToDate={setToDate}
        handleToggle={handleToggle}
        isChecked={isChecked}
        onInstructionClick={handleInstructionClick}
        instructionTaskIds={instructionTaskIds}
        tempFromDate={tempFromDate}
        tempToDate={tempToDate}
        setTempFromDate={setTempFromDate}
        setTempToDate={setTempToDate}
        FetchTaskCall={() => {
          if (props.fetchTasks) {
            props.fetchTasks(tempFromDate, tempToDate, props.setTasks);
            props.setFromDate(tempFromDate);
            props.setToDate(tempToDate);
          }
        }}
      />

      {showDetailsModal && selectedTask && (
        <TaskDetailsModal
          show={showDetailsModal}
          task={selectedTask}
          onClose={() => setShowDetailsModal(false)}
          assignmentLogs={assignmentLogs}
          statusChangeLogs={statusChangeLogs}
          showLogs={showLogs}
          setShowLogs={setShowLogs}
          onFetchLogs={async (taskId) => {
            const data = await fetchTaskLogs(taskId);
            setAssignmentLogs(data.assignmentLogs);
            setStatusChangeLogs(data.statusChangeLogs);
          }}
          onStatusChange={async (taskId, newStatus) => {
            const success = await handleChangeStatus(
              taskId,
              newStatus,
              selectedTask?.driver_id,
            );

            if (success) {
              setShowDetailsModal(false);
            }
          }}
          onOpenAssignModal={(task) => {
            setTaskToAssign(task);

            const taskShopCode =
              task?.shopcode || task?.shop_code || task?.restaurant_code;

            const matchedTeam = teams?.find((t) =>
              t.shopList?.some(
                (s) => s.shop_code?.toString() === taskShopCode?.toString(),
              ),
            );

            if (matchedTeam) {
              setSelectedAssignTeam(matchedTeam.team_name);
              setAssignTab("team");
            }

            setShowAssignModal(true);
          }}
        />
      )}

      {/* MIDDLE MAP */}
      <MapPanel tasks={tasks} agents={agents} />

      {/* RIGHT AGENTS */}
      <AgentPanel
        agents={agents}
        filteredAgents={filteredAgents}
        selectedAgentTab={selectedAgentTab}
        setSelectedAgentTab={setSelectedAgentTab}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        FetchDriverCall={FetchDriverCall}
        setNotificationAgent={setNotificationAgent}
        setNotificationModalOpen={setNotificationModalOpen}
      />

      <AssignModal
        show={showAssignModal}
        onClose={() => setShowAssignModal(false)}
        teams={teams}
        assignTab={assignTab}
        setAssignTab={setAssignTab}
        selectedAssignTeam={selectedAssignTeam}
        setSelectedAssignTeam={setSelectedAssignTeam}
        teamDrivers={teamDrivers}
        allTeamDrivers={allTeamDrivers}
        selectedAgentId={selectedAgentId}
        setSelectedAgentId={setSelectedAgentId}
        handleAssignTask={async () => {
          if (!selectedAgentId || !taskToAssign) return;

          try {
            await handleChangeStatus(
              taskToAssign.pk_task_id,
              "unassigned",
              null,
            );

            const success = await AssignTaskToDriver(
              taskToAssign.pk_task_id,
              selectedAgentId,
            );

            if (success) {
              setShowAssignModal(false);
              setSelectedAgentId("");
            }
          } catch (err) {
            console.error("Assign flow error:", err);
          }
        }}
      />

      {instructionModalOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white p-5 rounded-xl w-[520px] shadow-lg">
            <h2 className="text-lg font-bold mb-3">Customer Instructions</h2>

            {loadingInst ? (
              <p>Loading...</p>
            ) : Array.isArray(taskInstructions) &&
              taskInstructions.length > 0 ? (
              taskInstructions.map((i) => (
                <div
                  key={i.pk_customer_delivery_instruction_id}
                  className="mb-3 border-b pb-3"
                >
                  <p className="font-semibold text-base">
                    {i.instuction_title || "Instruction"}
                  </p>

                  <p className="text-sm text-gray-600 mt-1">
                    <strong>Default note:</strong>{" "}
                    {i.instuction_description || "No description"}
                  </p>

                  {i.customer_instruction_messege && (
                    <p className="text-sm text-orange-700 mt-1">
                      <strong>Customer message:</strong>{" "}
                      {i.customer_instruction_messege}
                    </p>
                  )}

                  <p className="text-xs text-gray-600 mt-1">
                    Shop: {i.shop_name || "N/A"} • Task: {i.task_id}
                  </p>
                </div>
              ))
            ) : (
              <p className="text-gray-500">No instructions for this task.</p>
            )}

            <div className="mt-3 flex justify-end">
              <button
                onClick={() => {
                  setInstructionModalOpen(false);
                  setTaskInstructions([]);
                }}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SEND NOTIFICATION */}
      <SendNotificationModal
        isOpen={notificationModalOpen}
        onClose={() => setNotificationModalOpen(false)}
        driver={notificationAgent}
        baseurl={baseurl}
        token={token}
        setIsUnauthorised={setIsUnauthorised}
      />
    </div>
  );
}
